import ArrowIcon from '@mm/icons/general/ArrowIcon';
import classnames from 'classnames';
import React, { FunctionComponent } from 'react';
import styles from './CollapsibleContentContainer.module.css';

interface Props {
  css?: {
    container?: string;
    content?: string;
  };
  ordinal: string;
  title: string;
  color: string;
  expandedOnMount?: boolean;
  noContentLeftBorder?: boolean;
}

export const CollapsibleContentContainer: FunctionComponent<Props> = props => {
  const {
    css,
    ordinal,
    title,
    children,
    color,
    expandedOnMount,
    noContentLeftBorder,
  } = props;

  const [expanded, setExpanded] = React.useState(expandedOnMount ?? true);
  return (
    <div
      className={classnames(styles.container, css?.container, {
        [styles.expanded]: expanded,
      })}
      style={{ '--collapsible-content-container-color': color } as any}
    >
      <div className={styles.header} onClick={() => setExpanded(e => !e)}>
        <div className={styles.ordinal}>{ordinal}</div>
        <ArrowIcon
          arrowType="triangle"
          size={15}
          direction={expanded ? 'right' : 'top'}
          viewBox="0 0 8 14"
          className={styles.expandIcon}
        />
        <div className={styles.title}>{title}</div>
      </div>
      <div
        className={classnames(styles.content, css?.content, {
          [styles.content__noborder]: noContentLeftBorder,
        })}
      >
        {children}
      </div>
    </div>
  );
};
